/* eslint-disable no-param-reassign */
import {
  setListingAssets,
  setListingVariantAssets,
  setMasterAssets,
  setMasterVariantAssets,
} from './entityAdapter';

const mergeAssetInList = (assets, updatedAsset) => {
  if (!Array.isArray(assets) || !updatedAsset?._id) return assets;

  const index = assets.findIndex((asset) => String(asset._id) === String(updatedAsset._id));
  if (index === -1) return assets;

  const nextAssets = [...assets];
  nextAssets[index] = { ...nextAssets[index], ...updatedAsset };
  return nextAssets;
};

/**
 * Merges an updated asset document into every products-store asset pool.
 */
export default function patchAssetInAllPools(state, updatedAsset) {
  if (!updatedAsset?._id || !state) return;

  const pools = state.entities?.assets;
  if (pools) {
    Object.entries(pools.listingAssets || {}).forEach(([listingProductId, assets]) => {
      const nextAssets = mergeAssetInList(assets, updatedAsset);
      if (nextAssets !== assets) {
        setListingAssets(state, listingProductId, nextAssets);
      }
    });

    Object.entries(pools.masterAssets || {}).forEach(([masterProductId, assets]) => {
      const nextAssets = mergeAssetInList(assets, updatedAsset);
      if (nextAssets !== assets) {
        setMasterAssets(state, masterProductId, nextAssets);
      }
    });

    Object.entries(pools.listingVariantAssets || {}).forEach(([listingVariantId, assets]) => {
      const nextAssets = mergeAssetInList(assets, updatedAsset);
      if (nextAssets !== assets) {
        setListingVariantAssets(state, listingVariantId, nextAssets);
      }
    });

    Object.entries(pools.masterVariantAssets || {}).forEach(([masterVariantId, assets]) => {
      const nextAssets = mergeAssetInList(assets, updatedAsset);
      if (nextAssets !== assets) {
        setMasterVariantAssets(state, masterVariantId, nextAssets);
      }
    });
  }

  (state.items || []).forEach((product) => {
    if (!product?.assets?.length) return;

    const nextAssets = mergeAssetInList(product.assets, updatedAsset);
    if (nextAssets === product.assets) return;

    product.assets = nextAssets;
    setMasterAssets(state, product._id, nextAssets);
  });
}
